module.exports = __webpack_public_path__ + "static/media/silhouette2.71b883e6.jpeg";